import { render, staticRenderFns } from "./chatGroupCreateDialog.vue?vue&type=template&id=a89efa8c&scoped=true"
import script from "./chatGroupCreateDialog.vue?vue&type=script&lang=js"
export * from "./chatGroupCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./chatGroupCreateDialog.vue?vue&type=style&index=0&id=a89efa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89efa8c",
  null
  
)

export default component.exports